import React from "react";
import PropTypes from "prop-types";
import { Divider } from "@qgiv/core-donor";
import ConnectedStoreCartSummary from "./ConnectedStoreCartSummary";

const StoreCartList = ({
    formattedShippingCost,
    formattedStoreTax,
    displayBottomDivider,
    displayShipping,
    isCms,
    renderStoreCartItems = () => {},
    shippingLabel,
    storeCart = [],
    taxLabel,
    taxRate,
}) => (
    // eslint-disable-next-line tailwindcss/classnames-order
    <div className="grid grid--no-gutters">
        <div className="col col--12">
            {/* eslint-disable-next-line tailwindcss/classnames-order */}
            <div className="grid grid--no-gutters">
                {isCms
                    ? renderStoreCartItems(storeCart)
                    : storeCart.map((storeCartItem, i) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <div className="col col--12" key={i}>
                              <ConnectedStoreCartSummary storeCartIndex={i} />
                          </div>
                      ))}
            </div>

            {displayShipping && (
                <>
                    <Divider
                        classNames="registration-summary__divider"
                        dashed
                    />
                    <div className="col col--12 col--no-gutter">
                        {/* eslint-disable-next-line tailwindcss/classnames-order */}
                        <div className="grid grid--no-gutters">
                            <div className="col">
                                <small>{shippingLabel}</small>
                            </div>
                            <div className="col -text--right">
                                <small>{formattedShippingCost}</small>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {formattedStoreTax && taxRate > 0 && (
                <>
                    <Divider
                        classNames="registration-summary__divider"
                        dashed
                    />
                    <div className="col col--12 col--no-gutter">
                        {/* eslint-disable-next-line tailwindcss/classnames-order */}
                        <div className="grid grid--no-gutters">
                            <div className="col">
                                <small>{`${taxLabel} ${taxRate}%`}</small>
                            </div>
                            <div className="col -text--right">
                                <small>{formattedStoreTax}</small>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
        {displayBottomDivider && (
            <Divider classNames="registration-summary__divider" />
        )}
    </div>
);

StoreCartList.propTypes = {
    // Flag telling us to display the solid divider below the list of StoreCarts
    // if $0 product and $0 shipping
    displayBottomDivider: PropTypes.bool.isRequired,
    displayShipping: PropTypes.bool.isRequired,
    // Currency formatted taxes added based on Store items totaled
    formattedStoreTax: PropTypes.string.isRequired,
    // Currency formatted shipping method cost
    formattedShippingCost: PropTypes.string.isRequired,
    isCms: PropTypes.bool.isRequired,
    // CMS rendering of ConnectedStoreCartSummary
    renderStoreCartItems: PropTypes.func,
    shippingLabel: PropTypes.string.isRequired,
    // Array of registration objects to map over
    storeCart: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    // Number representation of tax rate percentage
    taxLabel: PropTypes.string.isRequired,
    taxRate: PropTypes.number.isRequired,
};

export default StoreCartList;
